import type * as Types from '../../../../../../graphql/base-types.graphql';

import { gql } from '@apollo/client';
import { OsrValidatorErrorFieldsFragmentDoc } from '../../../../../../graphql/gql-fragments/options-shares-registration.graphql';
import { ScWithMinMaxFieldsFragmentDoc, ScFieldsFragmentDoc } from '../../../../../../graphql/gql-fragments/share-class.graphql';
import { IdentityFieldsFragmentDoc } from '../../../../../../graphql/gql-fragments/identity.graphql';
import { FileFieldsFragmentDoc } from '../../../../../../graphql/gql-fragments/document.graphql';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GqlStepOsrSubscribersQueryVariables = Types.Exact<{
  companyId: Types.Scalars['ID']['input'];
  osrId: Types.Scalars['ID']['input'];
}>;


export type GqlStepOsrSubscribersQuery = { optionsSharesRegistrationErrors: { decision: { completed: boolean, hasError: boolean, severity: Types.GqlSeverity, error?: { sv: { short?: string | null, long?: string | null }, en: { short?: string | null, long?: string | null } } | null }, recordDay: { completed: boolean, hasError: boolean, severity: Types.GqlSeverity, error?: { sv: { short?: string | null, long?: string | null }, en: { short?: string | null, long?: string | null } } | null }, participants: { completed: boolean, hasError: boolean, severity: Types.GqlSeverity, error?: { sv: { short?: string | null, long?: string | null }, en: { short?: string | null, long?: string | null } } | null }, signsRegForm: { completed: boolean, hasError: boolean, severity: Types.GqlSeverity, error?: { sv: { short?: string | null, long?: string | null }, en: { short?: string | null, long?: string | null } } | null }, payBeforeDate: { completed: boolean, hasError: boolean, severity: Types.GqlSeverity, error?: { sv: { short?: string | null, long?: string | null }, en: { short?: string | null, long?: string | null } } | null }, options: { completed: boolean, hasError: boolean, severity: Types.GqlSeverity, error?: { sv: { short?: string | null, long?: string | null }, en: { short?: string | null, long?: string | null } } | null }, todos: { completed: boolean, hasError: boolean, severity: Types.GqlSeverity, error?: { sv: { short?: string | null, long?: string | null }, en: { short?: string | null, long?: string | null } } | null } }, optionsSharesRegistration: { id: string, splitFactor: string, recordDay?: string | null, warrantProgram: { id: string, name?: string | null, description: string, paidForAt?: string | null, warrantStartDate?: string | null, companyId: string, warrantKind: Types.GqlWarrantProgramKind, usesStepper: boolean, shareClasses: Array<{ name: string, voteWeight: string, quantity?: string | null, min: string, max: string }>, meetingConcern?: { id: string, meetingId: string } | null, company: { id: string, name: string }, optionsSharesRegistrations: Array<{ id: string, splitFactor: string, subscribers: Array<{ id: string, identityId: string, quantity: string, shareClass: { name: string, voteWeight: string, quantity?: string | null }, identity: { id: string, identityNumberKind: number, identityNumber: string, juridicalKind: number, name: string, email?: string | null, emailMd5?: string | null, phone?: string | null, countryCode?: string | null, address?: string | null, userId?: string | null, isSwedish: boolean, createdAt: string, updatedAt: string, companyId: string } }> }>, optionsRegistrations: Array<{ id: string, participants: Array<{ id: string, identityId: string, vestingKind: number, vestingDuration: number, vestingAcceleration: boolean, vestingCliffDuration: number, vestingFrequency: number, quantity?: string | null, identity: { id: string, identityNumberKind: number, identityNumber: string, juridicalKind: number, name: string, email?: string | null, emailMd5?: string | null, phone?: string | null, countryCode?: string | null, address?: string | null, userId?: string | null, isSwedish: boolean, createdAt: string, updatedAt: string, companyId: string }, shareClass: { name: string, voteWeight: string, quantity?: string | null }, vestingOccasions: Array<{ id: string, vestingDate?: string | null, quantity: string, sortOrder: number }> }> }> }, subscribers: Array<{ id: string, identityId: string, quantity: string, paymentStatus: number, optionsSharesRegistrationId: string, shareClass: { name: string, voteWeight: string, quantity?: string | null }, identity: { id: string, identityNumberKind: number, identityNumber: string, juridicalKind: number, name: string, email?: string | null, emailMd5?: string | null, phone?: string | null, countryCode?: string | null, address?: string | null, userId?: string | null, isSwedish: boolean, createdAt: string, updatedAt: string, companyId: string }, latestShareSubscriptionListDoc?: { id: string, companyId: string, mimeType: string, filename: string, filesize?: number | null, sha256?: string | null, signedFilesize?: number | null, signedSha256?: string | null, signatureMethod?: Types.GqlDocumentSignatureMethod | null, dirty: boolean, scriveMtime?: string | null, scriveCtime?: string | null, scriveStatus?: Types.GqlScriveDocumentStatus | null, scriveParties?: any | null, scriveTimeoutTime?: string | null, zignedAgreementStatus?: Types.GqlZignedAgreementStatus | null, signAllowedAction: Types.GqlSignAllowedAction, hasSignStatus: boolean, hasThumbnail: boolean, kind: Types.GqlDocSystemTagKind, groupId?: string | null, userTags?: Array<string> | null, genState: Types.GqlDocGenState, uploaded: boolean, reminderSentAt?: string | null, deletable: boolean, softDeletable: boolean, createdAt: string, updatedAt: string, sharedWithShareholders: boolean } | null, representatives: Array<{ id: string, identity: { id: string, identityNumberKind: number, identityNumber: string, juridicalKind: number, name: string, email?: string | null, emailMd5?: string | null, phone?: string | null, countryCode?: string | null, address?: string | null, userId?: string | null, isSwedish: boolean, createdAt: string, updatedAt: string, companyId: string } }> }> } };

export type GqlOsrVestedAndAllocatedQueryVariables = Types.Exact<{
  companyId: Types.Scalars['ID']['input'];
  id: Types.Scalars['ID']['input'];
}>;


export type GqlOsrVestedAndAllocatedQuery = { osrVestedAndAllocated: Array<{ vested: string, total: string, allocated: string, subscribable: string, identity: { id: string, identityNumberKind: number, identityNumber: string, juridicalKind: number, name: string, email?: string | null, emailMd5?: string | null, phone?: string | null, countryCode?: string | null, address?: string | null, userId?: string | null, isSwedish: boolean, createdAt: string, updatedAt: string, companyId: string }, shareClass: { name: string, voteWeight: string, quantity?: string | null } }> };

export type GqlOssCreateMutationVariables = Types.Exact<{
  companyId: Types.Scalars['ID']['input'];
  input: Types.GqlOssCreateInput;
}>;


export type GqlOssCreateMutation = { ossCreate: { createdAt: string, id: string, identityId: string, optionsSharesRegistrationId: string, paymentStatus: number, quantity: string, updatedAt: string, shareClass: { name: string, voteWeight: string, quantity?: string | null } } };

export type GqlOssUpdateMutationVariables = Types.Exact<{
  companyId: Types.Scalars['ID']['input'];
  input: Types.GqlOssUpdateInput;
}>;


export type GqlOssUpdateMutation = { ossUpdate: { optionsSharesSubscriber: { id: string } } };


export const StepOsrSubscribersDocument = gql`
    query StepOsrSubscribers($companyId: ID!, $osrId: ID!) {
  optionsSharesRegistrationErrors(id: $osrId, companyId: $companyId) {
    ...OsrValidatorErrorFields
  }
  optionsSharesRegistration(companyId: $companyId, id: $osrId) {
    id
    splitFactor
    recordDay
    warrantProgram {
      id
      name
      description
      paidForAt
      warrantStartDate
      companyId
      warrantKind
      usesStepper
      shareClasses {
        ...ScWithMinMaxFields
      }
      meetingConcern {
        id
        meetingId
      }
      company {
        id
        name
      }
      optionsSharesRegistrations {
        id
        splitFactor
        subscribers {
          id
          identityId
          shareClass {
            ...ScFields
          }
          quantity
          identity {
            ...IdentityFields
          }
        }
      }
      optionsRegistrations {
        id
        participants {
          id
          identityId
          identity {
            ...IdentityFields
          }
          shareClass {
            ...ScFields
          }
          vestingKind
          vestingDuration
          vestingAcceleration
          vestingCliffDuration
          vestingFrequency
          quantity
          vestingOccasions {
            id
            vestingDate
            quantity
            sortOrder
          }
        }
      }
    }
    subscribers {
      id
      identityId
      quantity
      paymentStatus
      shareClass {
        ...ScFields
      }
      optionsSharesRegistrationId
      identity {
        ...IdentityFields
      }
      latestShareSubscriptionListDoc {
        ...FileFields
      }
      representatives {
        id
        identity {
          ...IdentityFields
        }
      }
    }
  }
}
    ${OsrValidatorErrorFieldsFragmentDoc}
${ScWithMinMaxFieldsFragmentDoc}
${ScFieldsFragmentDoc}
${IdentityFieldsFragmentDoc}
${FileFieldsFragmentDoc}`;

/**
 * __useStepOsrSubscribersQuery__
 *
 * To run a query within a React component, call `useStepOsrSubscribersQuery` and pass it any options that fit your needs.
 * When your component renders, `useStepOsrSubscribersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStepOsrSubscribersQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      osrId: // value for 'osrId'
 *   },
 * });
 */
export function useStepOsrSubscribersQuery(baseOptions: Apollo.QueryHookOptions<GqlStepOsrSubscribersQuery, GqlStepOsrSubscribersQueryVariables> & ({ variables: GqlStepOsrSubscribersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GqlStepOsrSubscribersQuery, GqlStepOsrSubscribersQueryVariables>(StepOsrSubscribersDocument, options);
      }
export function useStepOsrSubscribersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlStepOsrSubscribersQuery, GqlStepOsrSubscribersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GqlStepOsrSubscribersQuery, GqlStepOsrSubscribersQueryVariables>(StepOsrSubscribersDocument, options);
        }
export function useStepOsrSubscribersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GqlStepOsrSubscribersQuery, GqlStepOsrSubscribersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GqlStepOsrSubscribersQuery, GqlStepOsrSubscribersQueryVariables>(StepOsrSubscribersDocument, options);
        }
export type StepOsrSubscribersQueryHookResult = ReturnType<typeof useStepOsrSubscribersQuery>;
export type StepOsrSubscribersLazyQueryHookResult = ReturnType<typeof useStepOsrSubscribersLazyQuery>;
export type StepOsrSubscribersSuspenseQueryHookResult = ReturnType<typeof useStepOsrSubscribersSuspenseQuery>;
export type StepOsrSubscribersQueryResult = Apollo.QueryResult<GqlStepOsrSubscribersQuery, GqlStepOsrSubscribersQueryVariables>;
export const OsrVestedAndAllocatedDocument = gql`
    query OsrVestedAndAllocated($companyId: ID!, $id: ID!) {
  osrVestedAndAllocated(companyId: $companyId, id: $id) {
    identity {
      ...IdentityFields
    }
    shareClass {
      ...ScFields
    }
    vested
    total
    allocated
    subscribable
  }
}
    ${IdentityFieldsFragmentDoc}
${ScFieldsFragmentDoc}`;

/**
 * __useOsrVestedAndAllocatedQuery__
 *
 * To run a query within a React component, call `useOsrVestedAndAllocatedQuery` and pass it any options that fit your needs.
 * When your component renders, `useOsrVestedAndAllocatedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOsrVestedAndAllocatedQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useOsrVestedAndAllocatedQuery(baseOptions: Apollo.QueryHookOptions<GqlOsrVestedAndAllocatedQuery, GqlOsrVestedAndAllocatedQueryVariables> & ({ variables: GqlOsrVestedAndAllocatedQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GqlOsrVestedAndAllocatedQuery, GqlOsrVestedAndAllocatedQueryVariables>(OsrVestedAndAllocatedDocument, options);
      }
export function useOsrVestedAndAllocatedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlOsrVestedAndAllocatedQuery, GqlOsrVestedAndAllocatedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GqlOsrVestedAndAllocatedQuery, GqlOsrVestedAndAllocatedQueryVariables>(OsrVestedAndAllocatedDocument, options);
        }
export function useOsrVestedAndAllocatedSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GqlOsrVestedAndAllocatedQuery, GqlOsrVestedAndAllocatedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GqlOsrVestedAndAllocatedQuery, GqlOsrVestedAndAllocatedQueryVariables>(OsrVestedAndAllocatedDocument, options);
        }
export type OsrVestedAndAllocatedQueryHookResult = ReturnType<typeof useOsrVestedAndAllocatedQuery>;
export type OsrVestedAndAllocatedLazyQueryHookResult = ReturnType<typeof useOsrVestedAndAllocatedLazyQuery>;
export type OsrVestedAndAllocatedSuspenseQueryHookResult = ReturnType<typeof useOsrVestedAndAllocatedSuspenseQuery>;
export type OsrVestedAndAllocatedQueryResult = Apollo.QueryResult<GqlOsrVestedAndAllocatedQuery, GqlOsrVestedAndAllocatedQueryVariables>;
export const OssCreateDocument = gql`
    mutation OssCreate($companyId: ID!, $input: OssCreateInput!) {
  ossCreate(companyId: $companyId, input: $input) {
    createdAt
    id
    identityId
    optionsSharesRegistrationId
    paymentStatus
    quantity
    shareClass {
      ...ScFields
    }
    updatedAt
  }
}
    ${ScFieldsFragmentDoc}`;
export type GqlOssCreateMutationFn = Apollo.MutationFunction<GqlOssCreateMutation, GqlOssCreateMutationVariables>;

/**
 * __useOssCreateMutation__
 *
 * To run a mutation, you first call `useOssCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOssCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [ossCreateMutation, { data, loading, error }] = useOssCreateMutation({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useOssCreateMutation(baseOptions?: Apollo.MutationHookOptions<GqlOssCreateMutation, GqlOssCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GqlOssCreateMutation, GqlOssCreateMutationVariables>(OssCreateDocument, options);
      }
export type OssCreateMutationHookResult = ReturnType<typeof useOssCreateMutation>;
export type OssCreateMutationResult = Apollo.MutationResult<GqlOssCreateMutation>;
export type OssCreateMutationOptions = Apollo.BaseMutationOptions<GqlOssCreateMutation, GqlOssCreateMutationVariables>;
export const OssUpdateDocument = gql`
    mutation OssUpdate($companyId: ID!, $input: OssUpdateInput!) {
  ossUpdate(input: $input, companyId: $companyId) {
    optionsSharesSubscriber {
      id
    }
  }
}
    `;
export type GqlOssUpdateMutationFn = Apollo.MutationFunction<GqlOssUpdateMutation, GqlOssUpdateMutationVariables>;

/**
 * __useOssUpdateMutation__
 *
 * To run a mutation, you first call `useOssUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOssUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [ossUpdateMutation, { data, loading, error }] = useOssUpdateMutation({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useOssUpdateMutation(baseOptions?: Apollo.MutationHookOptions<GqlOssUpdateMutation, GqlOssUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GqlOssUpdateMutation, GqlOssUpdateMutationVariables>(OssUpdateDocument, options);
      }
export type OssUpdateMutationHookResult = ReturnType<typeof useOssUpdateMutation>;
export type OssUpdateMutationResult = Apollo.MutationResult<GqlOssUpdateMutation>;
export type OssUpdateMutationOptions = Apollo.BaseMutationOptions<GqlOssUpdateMutation, GqlOssUpdateMutationVariables>;